import styled from "styled-components";

export const StyledBody = styled.main`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

export default StyledBody;
